<template>
<div class="chapter">
<div class="inner_page">
<p class="centerImage1"><a id="page_10"></a><img alt="images" src="images/f010-01.jpg"/></p>
<p class="caption">How British European Airways judged my chances of employment.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_fm02.vue?726d6a8e